import axios from "axios";
import Vue from "vue";
export const state = {
  students: [],
  students1: [],
  student: [],
  performance: [],
  allStudentsDetails: [],
  summery: [],
  save_status: false,
  performance_status: false,
  fetchingStudent: false,
  filteredPromotedStd: [],
  promotedStd: [],
  allSearchableStudents: [],
  archivedStudents: [],
  searchingStudents: false,
  searchedStudents: ""
};
export const getters = {
  AllStudents: (state) => state.students.data,
  AllStudents1: (state) => state.students1,
  GetStudentDetails: (state) => state.student,
  GetStudentPerf: (state) => state.performance,
  SaveStatus: (state) => state.save_status,
  GetAllStudentsDetails: (state) => state.allStudentsDetails.data,
  getAllSearchableStudents: (state) => state.allSearchableStudents,
  PerformanceStatus: (state) => state.performance_status,
  getStudentsSummery: (state) => state.summery.data,
  FetchingStudents: (state) => state.fetchingStudent,
  getFilteredStudents: (state) => state.filteredPromotedStd,
  getPromotedStudents: (state) => state.promotedStd,
  getFetchArchiveStudents: (state) => state.archivedStudents,
  getSearchingStudents: (state) => state.searchingStudents,
  getSearchedStudents: (state) => state.searchedStudents,
};

export const mutations = {
  SET_STUDENTS(state, newValue) {
    state.students = newValue;
  },
  SET_ARCHIVE_STUDENTS(state, newValue) {
    state.archivedStudents = newValue;
  },
  SET_STUDENTS1(state, newValue) {
    state.students1 = newValue;
  },
  SET_STUDENT(state, newValue) {
    state.student = newValue;
  },
  SET_ALLSTDDETAILS(state, newValue) {
    state.allStudentsDetails = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  SET_PERFORMACE_STATUS(state, newValue) {
    state.performance_status = newValue;
  },
  SET_PERFORMACE(state, newValue) {
    state.performance = newValue;
  },
  SET_SUMMERY(state, newValue) {
    state.summery = newValue;
  },
  SET_FETCHING_STD(state, newValue) {
    state.fetchingStudent = newValue;
  },
  SET_SEARCHABLE_STUDENTS(state, newValue) {
    state.allSearchableStudents = newValue;
  },
  SET_FILTERED_PROMO_STD(state, newValue) {
    state.filteredPromotedStd = newValue;
  },
  SET_PROMOTED_STUDENTS(state, newValue) {
    state.promotedStd = newValue;
  },
  SEARCHED_STUDENT(state, newValue) {
    state.searchedStudents = newValue;
  },
  SEARCHING_STD(state, newValue) {
    state.searchingStudents = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  //add student
  addStudent({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("students", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Student Was Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
        dispatch("fetchStudents");
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  //uploading students
  uploadStudent({ commit, dispatch }, { payload, stdFilter }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("student/upload", payload)
      .then((response) => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: response.data.msg,
        };
        commit("pushNotification", message);
        dispatch("fetchStudents", stdFilter);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While <b>Uploading Students</b>",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit Student
  editStudent({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`students/update`, payload.student_details)
      .then((response) => {
        console.log(response);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Student Updated Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
        dispatch("fetchStudents");
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Student
  deleteStudents({ commit, dispatch }, { payload, stdFilter }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get(`students/cancel/${payload.id}`)
      .then(() => {
        dispatch("fetchStudents", stdFilter);
        const message = {
          type: "default",
          title: "<b>Success Notifications</b>",
          message: "Student Canceled Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Canceling",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Delete Student this is from students details
  deleteStudent({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`students/cancel`, payload)
      .then((details) => {
        const message = {
          type: "default",
          title: "<b>Success Notifications</b>",
          message: "Student Canceled Successfully",
        };
        commit("pushNotification", message);
        commit("SET_STUDENT", details.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Canceling",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Delete Student this is from students details
  searchStudent({ commit }, payload) {
    commit("SEARCHING_STD", true);
    axios
      .post(`searchStudents`, payload)
      .then((details) => {
        commit("SET_ARCHIVE_STUDENTS", details.data);
        commit("SEARCHING_STD", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Searching",
        };
        commit("pushNotification", message);
        commit("SEARCHING_STD", false);
      });
  },

  //fetching all students
  fetchStudents({ commit }, payload) {
    commit("SET_FETCHING_STD", true);
    axios.post("students/fetch", payload).then((students) => {
      commit("SET_STUDENTS", students.data);
      commit("SET_FETCHING_STD", false);
    });
  },

  //fetching archive students
  fetchArchiveStudents({ commit }) {
    commit("FetchingStudents", true);
    axios.get("students_archive").then((students) => {
      commit("SET_ARCHIVE_STUDENTS", students.data);
      commit("FetchingStudents", false);
    });
  },

  //fetch all students for dashboard.
  fetchSearchableStudents({ commit }) {
    commit("SET_FETCHING_STD", true);
    axios.get("searchable_students").then((students) => {
      commit("SET_SEARCHABLE_STUDENTS", students.data);
      commit("SET_FETCHING_STD", false);
    });
  },

  //fetching all students
  fetchStudents1({ commit }) {
    commit("SET_FETCHING_STD", true);
    axios.get("view_students").then((students) => {
      commit("SET_STUDENTS1", students.data);
      commit("SET_FETCHING_STD", false);
    });
  },
  //fetch student details
  fetchStudent({ commit }, id) {
    commit("SET_SAVE_STATUS", true);
    axios.get(`student/details/${id}`).then((details) => {
      commit("SET_STUDENT", details.data);
      commit("SET_SAVE_STATUS", false);
    }).catch(() => {
        commit("SET_SAVE_STATUS", false);
    });
  },
  //fetching student performances
  fetchStudentPerf({ commit }, id) {
    commit("SET_PERFORMACE_STATUS", true);
    axios.get(`student/performance/${id}`).then((performance) => {
      commit("SET_PERFORMACE", performance.data);
      commit("SET_PERFORMACE_STATUS", false);
    });
  },
  //fetching student details
  fetchAllStudentDetails({ commit }, id) {
    commit("SET_SAVE_STATUS", true);
    axios.get(`student/edit/${id}`).then((details) => {
      commit("SET_ALLSTDDETAILS", details.data);
      commit("SET_SAVE_STATUS", false);
    });
  },
  //fetch students summery
  fetchStudentsSummery({ commit }, payload) {
    commit("SET_FETCHING_STD", true);
    axios.post("student/summery-filtered", payload).then((summery) => {
      commit("SET_SUMMERY", summery.data);
      commit("SET_FETCHING_STD", false);
    });
  },
};
